import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeocoderService {
  private apiKey = 'AIzaSyBiD8cxBm57QGVyp4CHGUreoZeKEpmH_go'; 
  private placesUrl = 'https://maps.googleapis.com/maps/api/place/autocomplete/json';
  private geocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json';

  constructor(private http: HttpClient) {}

  // Búsqueda de lugares con Places API
  searchPlacesGoogle(input: string, region: string = 'hn'): Observable<any[]> {
    const url = `${this.placesUrl}?input=${encodeURIComponent(input)}&key=${this.apiKey}&components=country:${region}&region=${region}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        if (response.status === 'OK') {
          return response.predictions.slice(0, 5);
        }
        return [];
      }),
      catchError((error) => {
        return of([]);
      })
    );
  }

  getPlaceDetails(placeId: string): Observable<any> {
    const fields = 'address_components,geometry';
    const url = `https://maps.googleapis.com/maps/api/place/details/json?place_id=${placeId}&fields=${fields}&key=${this.apiKey}`;
  
    return this.http.get<any>(url).pipe(
      map((response) => {
        if (response.status === 'OK') {
          const result = response.result;
          const components = result.address_components;
  
          const extract = (type: string) => {
            const found = components.find((c: any) => c.types.includes(type));
            return found ? found.long_name : null;
          };

          return {
            city: extract('locality'),
            department: extract('administrative_area_level_1'),
            country: extract('country'),
            postalCode: extract('postal_code'),
            location: result.geometry?.location ?? null
          };
        }
        return null;
      }),
      catchError((error) => {
        return of(null);
      })
    );
  }
  

  reverseGeocode(lat: number, lng: number): Observable<any> {
    const url = `${this.geocodeUrl}?latlng=${lat},${lng}&key=${this.apiKey}`;
    return this.http.get<any>(url).pipe(
      map((response) => {
        if (response.status === 'OK' && response.results.length > 0) {
          const result = response.results[0];
          const components = result.address_components;
  
          const extract = (type: string) => {
            const found = components.find((c: any) => c.types.includes(type));
            return found ? found.long_name : null;
          };

          return {
            address_name: result.formatted_address,
            city: extract('locality'),
            department: extract('administrative_area_level_1'),
            country: extract('country'),
            postalCode: extract('postal_code'),
            location: result.geometry?.location ?? null
          };
        }
        return null;
      })
    );
  }
}